import React from "react";

import { Auth } from "shared/@auth/Auth";

import { DreamCastContent } from ".";

export default function DreamCast(props) {
  const { hasPermission, makeAuthedRequest } = Auth.useContainer();

  return (
    <DreamCastContent
      {...props}
      hasPermission={hasPermission}
      makeAuthedRequest={makeAuthedRequest}
    />
  );
}
